import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { AUTOCOMPLETE_MAX_ITEMS } from '../../utils/constants';
import { CancelToken } from 'axios';
import { Questionnaire } from '../../models/training';
import { EntityState } from '@api/models/enums/EntityState';
import { QuestionnaireDto } from '@api/models/questionnaire/QuestionnaireDto';
import { questionnaireService } from '@api/services/services';

type State = BaseType<QuestionnaireDto[]>;

const initialState: State = {
  state: FetchState.None,
  data: [],
};

export const optionsQuestionnaireSlice = baseSlice({
  name: 'optionsQuestionnaire',
  initialState,
});

export const selectOptionsQuestionnaireState = (state: RootState) => state.optionsQuestionnaire.state;

export const selectOptionsQuestionnaire = (state: RootState) =>
  state.optionsQuestionnaire.data.map(
    (x) =>
      ({
        id: x.id,
        name: x.name,
        nameEn: x.nameEn,
        missingLanguageVariant: x.missingLanguageVariant,
      }) as Questionnaire,
  );

export const optionsQuestionnaireActions = optionsQuestionnaireSlice.actions;

export const getOptionsQuestionnaire =
  (search: string | undefined, skipId: string | undefined, cancelToken: CancelToken) => (dispatch: AppDispatch) => {
    const handleGetData = async () => {
      const response = await questionnaireService.query(
        {
          q: search,
          state: EntityState.Active,
          skipId: skipId,
          nameOnly: true,
          page: 0,
          size: AUTOCOMPLETE_MAX_ITEMS,
          sort: ['name', 'asc'],
        },
        { cancelToken: cancelToken },
      );
      return { data: response.data.content ?? [] };
    };

    getItem({
      dispatch,
      actions: optionsQuestionnaireActions,
      getData: handleGetData,
    });
  };
